// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NVp7CD3svbc9kotd{display:flex}.NVp7CD3svbc9kotd .EnGDfTeXkoVEfpE1{color:var(--py-red-6)}.NVp7CD3svbc9kotd .LQo_iVjwLgkT3ore{color:var(--py-green-5)}.NVp7CD3svbc9kotd .cEt94bBRGikqpQuG{color:var(--py-neutral-7)}.NVp7CD3svbc9kotd .uZP4z4WCEn_hehgI{margin-left:4px}.NVp7CD3svbc9kotd .hfleIURfhZwVHdzP{width:14px;align-items:start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorAlertContainer": `NVp7CD3svbc9kotd`,
	"error": `EnGDfTeXkoVEfpE1`,
	"success": `LQo_iVjwLgkT3ore`,
	"neutral": `cEt94bBRGikqpQuG`,
	"message": `uZP4z4WCEn_hehgI`,
	"icon": `hfleIURfhZwVHdzP`
};
export default ___CSS_LOADER_EXPORT___;
